import { z } from 'zod';
import { c } from '../../../contract';
import { GetRetentionMessageResponse } from '../../../types/RetentionMessaging';

export const retentionMessagingRouter = c.router(
  {
    getMessage: {
      method: 'POST',
      path: '/',
      body: z.object({
        signedPayload: z.string(),
      }),
      responses: {
        200: GetRetentionMessageResponse,
      },
    },
  },
  {
    pathPrefix: '/retention-messaging',
  },
);
